import flatpickr from "flatpickr";


function initDateTimePicker(selector){
    flatpickr(selector, {
        enableTime: true,
        dateFormat: "Y-m-d H:i",
        time_24hr: true,
        minuteIncrement: 1,
    });
}
document.addEventListener("DOMContentLoaded", function() {
    initDateTimePicker(".datetime-picker");
});
